import { Text, Inline, Column, Columns, Stack } from 'braid-design-system';

export type LabelValueField = {
  label: string;
  value: string;
};

interface LabelValueFieldsProps {
  fields: LabelValueField[];
}

const LabelValueFields = ({ fields }: LabelValueFieldsProps) => (
  <Stack space="small">
    {fields.map(({ label, value }, i) => (
      <Columns space="xxsmall" collapseBelow="tablet" key={i}>
        <Column width="1/5">
          <Inline alignY="center" space="xxsmall">
            <Text size="small" tone="secondary">
              {label}
            </Text>
          </Inline>
        </Column>
        <Column>
          <Inline alignY="center" space="xxsmall">
            <Text size="small">{value}</Text>
          </Inline>
        </Column>
      </Columns>
    ))}
  </Stack>
);

export { LabelValueFields };
